import React, { useState } from 'react'

import { ImprestFormatTable, PortalBasicSettings, ProcessApprovalFlowSettings, ProcessFlowSettings } from './PortalSettingsTables';
import { SalaryStructureHeadingTable } from '../../workforcemanagement/Organizationtables';
import { LetterTemplatesTable } from '../../DynamicBuilders/LetterBuilderManagement/LetterTemplateTables';
import { SlipBuilderCategories, SlipBuilderTemplates } from '../../DynamicBuilders/SlipBuilderManagement/SlipBuilderTables';
import { AppraisalQuickFormSetup } from '../../AppraisalManagement/AppraisalTables';
import usePermission from '../../../config/permissions';
import SandwichRuleManagements from '../../UserDetails/SandwichRuleManagement/SandwichRuleManagements';
import AttendanceSyncAndRLM from '../../UserDetails/AttendanceSyncAndRLM';
import RunFixedAssetsAttendance from '../../UserDetails/RunFixedAssetsAttendance';

const GeneralSettings = () => {

    const [toggleState, setToggleState] = useState(1);
    const { PERMISSION_HR_ADMIN, PERMISSION_AUTHORITY } = usePermission();
    return (
        <>
            <div>
                <div className="bloc-tabss  wfm-margin">

                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Portal Basic Settings
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Process Flow Settings
                    </button>
                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Imprest Headings
                    </button>
                    <button
                        className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(4)}
                    >
                        Salary Structure Headings
                    </button>
                    <button
                        className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(5)}
                    >
                        Letter Template Builder
                    </button>
                    <button
                        className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(6)}
                    >
                        Quick Appraisal Setup
                    </button>
                    {/* <button
                        className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(7)}
                    >
                        Slip Categories
                    </button>
                    <button
                        className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(8)}
                    >
                        Slip Builder
                    </button> */}

                    {
                        (PERMISSION_HR_ADMIN || PERMISSION_AUTHORITY) &&
                        <>
                            <button
                                className={
                                    toggleState === 9
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading dashboardcomponent-tabss   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
                                }
                                onClick={() => { setToggleState(9) }}
                            >
                                Sandwich Rule
                            </button>

                            <button
                                className={
                                    toggleState === 10
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading dashboardcomponent-tabss  dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
                                }
                                onClick={() => { setToggleState(10) }}
                            >
                                Attendance Sync & RLM Execution
                            </button>
                            <button
                                className={
                                    toggleState === 11
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading dashboardcomponent-tabss  dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
                                }
                                onClick={() => { setToggleState(11) }}
                            >
                                Run Fixed Assests Attendance
                            </button>

                        </>
                    }
                </div>

                <div className="content-tabs">
                    {toggleState === 1 ? <PortalBasicSettings /> : null}

                    {toggleState === 2 ? <ProcessApprovalFlowSettings /> : null}

                    {toggleState === 3 ? <ImprestFormatTable /> : null}

                    {toggleState === 4 ? <SalaryStructureHeadingTable /> : null}

                    {toggleState === 5 ? <LetterTemplatesTable /> : null}

                    {toggleState === 6 ? <AppraisalQuickFormSetup /> : null}

                    {toggleState === 7 ? <SlipBuilderCategories /> : null}

                    {toggleState === 8 ? <SlipBuilderTemplates /> : null}

                    {toggleState === 9 ? <SandwichRuleManagements /> : null}

                    {toggleState === 10 ? < AttendanceSyncAndRLM /> : null}

                    {toggleState === 11 ? <RunFixedAssetsAttendance /> : null}
                </div>
            </div>

        </>
    )
}

export default GeneralSettings
